export default __webpack_public_path__ + "static/media/turkey1.4cb62874.png";